// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Spin from 'antd/lib/spin';
import Empty from 'antd/lib/empty';
import Result from 'antd/lib/result';

import { getRunDetailAsync } from 'actions/labeling-runs-actions';
import { CombinedState } from 'reducers';
import TopBarComponent from './top-bar';
import RunTaskListComponent from './run-task-list';

export default function RunPage(): JSX.Element {
    const { id } = useParams<{ id: string }>();
    const runId = parseInt(id, 10);
    const dispatch = useDispatch();
    const fetching = useSelector((state: CombinedState) => state.activeRun.fetching);
    const run = useSelector((state: CombinedState) => state.activeRun.run);
    const tasks = useSelector((state: CombinedState) => state.activeRun.tasks);

    useEffect(() => {
        dispatch(getRunDetailAsync(runId) as any);
    }, [runId]);

    if (fetching) {
        return <Spin size='large' className='cvat-spinner' />;
    }

    if (!run) {
        return (
            <Result
                className='cvat-not-found'
                status='404'
                title='Run not found'
                subTitle='The labeling run you requested does not exist or you do not have access to it.'
            />
        );
    }

    return (
        <div className='cvat-run-page' style={{ paddingTop: 16, height: '100%', overflow: 'auto' }}>
            <TopBarComponent run={run} runId={runId} />
            {tasks.length ? (
                <RunTaskListComponent runId={runId} />
            ) : (
                <Empty description='No tasks in this run yet. Click + to add tasks.' />
            )}
        </div>
    );
}
